import * as React from "react";
import { forwardRef } from "react";
const SvgInfoDynamic = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, fill: "none", viewBox: "0 0 10 10", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M5 4.167a.417.417 0 0 1 .417.416v2.5a.417.417 0 1 1-.834 0v-2.5A.417.417 0 0 1 5 4.167m0-.625a.625.625 0 1 0 0-1.247.625.625 0 0 0 0 1.245zM0 5a5 5 0 1 1 10 0A5 5 0 0 1 0 5M5 .833a4.167 4.167 0 1 0 0 8.334A4.167 4.167 0 0 0 5 .833" }));
const ForwardRef = forwardRef(SvgInfoDynamic);
export { ForwardRef as ReactComponent };
